var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16406 1.36719C3.28125 1.10938 3.53906 0.945312 3.82031 0.945312H6.65625C6.9375 0.945312 7.19531 1.10938 7.3125 1.36719L7.5 1.69531H9.75C10.1484 1.69531 10.5 2.04688 10.5 2.44531C10.5 2.86719 10.1484 3.19531 9.75 3.19531H0.75C0.328125 3.19531 0 2.86719 0 2.44531C0 2.04688 0.328125 1.69531 0.75 1.69531H3L3.16406 1.36719ZM9.23438 11.8906C9.21094 12.5 8.71875 12.9453 8.10938 12.9453H2.36719C1.75781 12.9453 1.26562 12.5 1.24219 11.8906L0.726562 3.94531H9.75L9.23438 11.8906Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_Trash.0925b9a69de3ce27ba80a2d1c70bafcf.svg";
export { ForwardRef as ReactComponent };